import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import cs from './locales/cs.json';
import en from './locales/en.json';
import de from './locales/de.json';

export const SUPPORTED_LNGS = ['cs', 'en', 'de'] as const;
export type Lang = (typeof SUPPORTED_LNGS)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: 'cs',
    supportedLngs: [...SUPPORTED_LNGS],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupCookie: 'wedding_lng',
      lookupLocalStorage: 'wedding_lng',
    },
  });

export default i18n;
